module.exports = __webpack_public_path__ + "media/images/stand_to_sit-7754ead4.png";